import { request } from '../shared/utils'

export const loadSiteData = (data = {}) =>
  request({
    url: '/api/site/get',
    method: 'GET',
    data,
  })

export const fetchSettings = () =>
  request({
    url: '/api/setting/list',
  })

export const getUser = () =>
  request({
    url: '/api/user/get',
    method: 'GET',
  })
